import { __decorate } from "tslib";
import { CHEMICAL_SERVICE_URI } from '@cores/constants/envConfig';
import _ from 'lodash';
import { provide } from '@/inversify.config';
const FRAME_ID = 'marvinjs-iframe';
const IFRAME_SETTINGS = {
    js: '/marvinjs_latest/js/marvinjslauncher.js',
    html: '/marvinjs_latest/marvinpack.html',
};
const SETTINGS = {
    imageType: 'image/svg',
    settings: {
        carbonLabelVisible: false,
        cpkColoring: true,
        implicitHydrogen: 'HETERO',
        width: 150,
        height: 150,
    },
    inputFormat: null,
    services: {
        molconvertws: `${CHEMICAL_SERVICE_URI}/webservices/rest-v1/util/calculate/molExport`,
    },
};
let loadJsChannel = Promise.resolve();
let getMarvinExporterInstanceChannel = Promise.resolve();
export const MarvinServiceSymbol = Symbol.for('MarvinService');
let MarvinService = class MarvinService {
    constructor() {
        this.marvinExporterInstance = undefined;
        this.jsCache = new Map();
        this.imageCache = new Map();
    }
    getMarvinExporterInstance(customSettings = {}) {
        const that = this;
        getMarvinExporterInstanceChannel = getMarvinExporterInstanceChannel.then(() => {
            if (this.marvinExporterInstance && (this.marvinExporterInstance.render || typeof this.marvinExporterInstance.then === 'function')) {
                return this.marvinExporterInstance;
            }
            return new Promise((resolve, reject) => {
                that.loadJs(IFRAME_SETTINGS.js).then((data) => {
                    that.createMarvinIframe();
                    window.MarvinJSUtil.getPackage(`#${FRAME_ID}`).then((marvin) => {
                        // 设置请求头
                        marvin.Sketch.addRequestInterceptor(config => {
                            config.setRequestHeader('X-API-Version', '2.0');
                        });
                        marvin.onReady(() => {
                            const imageExporter = new marvin.ImageExporter(_.merge(SETTINGS, customSettings));
                            this.marvinExporterInstance = imageExporter;
                            resolve(imageExporter);
                        });
                    }, (err) => {
                        that.marvinExporterInstance = undefined;
                        reject(err);
                    });
                }).catch(err => {
                    that.marvinExporterInstance = undefined;
                    reject(err);
                });
            });
        });
        return getMarvinExporterInstanceChannel;
    }
    createMarvinIframe() {
        if (document.querySelector(`#${FRAME_ID}`)) {
            return;
        }
        const fragment = document.createDocumentFragment();
        const iframe = document.createElement('iframe');
        iframe.setAttribute('id', FRAME_ID);
        iframe.setAttribute('src', IFRAME_SETTINGS.html);
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        fragment.appendChild(iframe);
        document.body.appendChild(fragment);
    }
    loadJs(src) {
        loadJsChannel = loadJsChannel.then(() => {
            if (this.jsCache.has(src)) {
                return Promise.resolve(this.jsCache.get(src));
            }
            return new Promise((resolve, reject) => {
                const ref = window.document.getElementsByTagName('head')[0];
                const script = window.document.createElement('script');
                script.src = src;
                ref.appendChild(script);
                script.onload = data => {
                    this.jsCache.set(src, data);
                    resolve(data);
                };
                script.onerror = error => {
                    reject(error);
                };
            });
        });
        return loadJsChannel;
    }
    // render
    render(smiles) {
        if (!smiles) {
            return Promise.resolve([smiles, '']);
        }
        if (this.imageCache.has(smiles)) {
            return Promise.resolve([smiles, this.imageCache.get(smiles)]);
        }
        return this.getMarvinExporterInstance().then(exporter => {
            return exporter.render(smiles);
        }).then(img => {
            this.imageCache.set(smiles, img);
            return [smiles, img];
        });
    }
};
MarvinService = __decorate([
    provide(MarvinServiceSymbol)
], MarvinService);
export { MarvinService };
